// My Downloads

<template>
  <div class="lms5040 container whitesmoke curved">
    <div class="content board whitesmoke">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li><sym-link :to="getPortalPagePath()">Portal</sym-link></li>
        <li><span aria-current="page">My Downloads</span></li>
      </Ul>

      <div class="page-title lams curved  mb-4">
        <h5 class="serif">
          <i class="fa fa-download fa-lg ml-1 mr-2"></i>My Downloads
        </h5>
      </div>

      <div class="text-center mb-2">
        <sym-combo
          v-model="regionId"
          :input-width="68"
          display-field="regionFullName"
          :datasource="regions"
          @changing="onRegionIdChanging"
          @changed="onRegionIdChanged"
        ></sym-combo>
      </div>

      <div class="downloads curved-1" v-show="documents.length">
        <sym-card
          v-for="(document, index) in documents"
          :key="index"
          bodyClass="P-1"
          headerClass="mb-1"
          class="lams-light border-main shadow-soft curved-1 mb-2"
        >
          <div slot="header">
            <div class="download-tag justify-between align-items-start mb-1">
              <p class="lg-1 mb-0" v-if="document.trxId">
                Transaction:
                <span class="display-10 bold">{{ document.trxId }}</span>
              </p>
              <p class="sm-1 mb-0" v-if="document.trxDate">
                Date/Time:
                <span class="sm-1">{{
                  core.toDateFormat(
                    document.trxDateTime,
                    true,
                    "dd MMM yyyy h:mmtt"
                  )
                }}</span>
              </p>
            </div>

            <div class="d-flex justify-between align-items-start">
              <sym-text
                v-model="document.tag"
                @changed="onUpdate(document)"
                class="w-100"
                cue="Label this download here."
              ></sym-text>
              <button
                type="button"
                class="info ml-2 w-10 text-center lg-1 shadow"
                title="Save label"
                @click="onUpdate(document)"
              >
                <i class="fa fa-save fa-lg"></i>
              </button>
            </div>
          </div>

          <div>
            <button
              type="button"
              class="warning w-100 text-center lg-2 shadow"
              v-if="document.trxId && !document.zipFileUrl"
              @click="onRequestLink(document)"
            >
              Request Download Link
            </button>
          </div>

          <div class="display-9" v-if="document.zipFileUrl">
            <a
              :href="document.zipFileUrl"
              class="button success w-100 text-center lg-2 shadow"
              ><i class="fa fa-download fa-lg mr-2"></i>Download</a
            >
          </div>
        </sym-card>
      </div>

      <button
        type="button"
        class="primary text-center w-100 lg-1 shadow mt-3 mb-2"
        @click="goBack()"
      >
        <i class="fa fa-arrow-left mr-2"></i> Back
      </button>
    </div>
  </div>
</template>

<script>
import { get, ajax } from "../../js/http";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms5040",

  data() {
    return {
      regions: [],
      regionId: 0,
      documents: [],
      item: [],
    };
  },

  methods: {
    onRequestLink(document) {
      const me = this,
        wait = me.wait();

      me.getLink(document.trxId).then(
        (link) => {
          me.stopWait(wait);
          document.zipFileUrl = link;
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    onRegionIdChanging(e) {
      const me = this;

      let regionInfo = me.regions.find(
        (obj) => obj.regionId === e.proposedValue
      );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }
    },

    regionIdCallback(e) {
      const me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        (statusCode) => {
          me.stopWait(wait);

          let isOnline = statusCode === 200;
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;
        }
      );
    },

    onRegionIdChanged() {
      const me = this;

      if (!me.regionId) {
        me.documents = [];
        return;
      }

      let wait = me.wait();

      me.getDownloads().then(
        (downloads) => {
          me.stopWait(wait);
          me.documents = downloads;
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    onUpdate(document) {
      const payload = this.getApiPayload(document),
        body = JSON.stringify(payload),
        options = this.core.getAjaxOptions("PUT", body);

      return ajax(
        "api/rgn/" + this.regionId + "/tag/" + document.trxId + "/update",
        options
      );
    },

    getLinkStatus(regionId) {
      return get("api/regions/" + regionId + "/link-status");
    },

    getApiPayload(document) {
      const obj = {};

      Object.assign(obj, document);
      return obj;
    },

    getRegions() {
      return get("api/accounts/" + this.accountCode + "/regions");
    },

    getDownloads() {
      return get(
        "api/rgn/" +
          this.regionId +
          "/accounts/" +
          this.accountCode +
          "/downloads"
      );
    },

    getLink(trxId) {
      // return get('api/rgn/' + this.regionId + '/transactions/' + trxId +  '/download-link')
      // // eslint-disable-next-line no-console
      // console.log(trxId);
      const q =
        "origin=" + window.location.origin + "&regionId=" + this.regionId;
      return get(
        "api/rgn/" +
          this.regionId +
          "/transactions/" +
          trxId +
          "/download-link?" +
          q
      );
    },

    getPortalPagePath() {
      let page = "",
        typeId = this.accountTypeId;

      if (typeId === 1) {
        page = "lms1010";
      }
      if (typeId === 2) {
        page = "lms1020";
      }
      if (typeId === 3) {
        page = "lms1030";
      }
      if (typeId === 4) {
        page = "lms1040";
      }
      if (page) {
        return this.sym.getPath(page);
      }
      return "/";
    },
  },

  created() {
    this.accountCode = "";
    this.accountTypeId = 0;
  },

  mounted() {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode;
    me.accountTypeId = me.sym.userInfo.accountTypeId;

    me.getRegions().then(
      (regions) => {
        regions.unshift({
          regionId: 0,
          regionFullName: "--- Select Region ---",
        });
        me.regions = regions;

        // if (regions.length === 2) {
        //   me.regionId = regions[1].regionId;
        //   me.onRegionIdChanged();
        // }
        me.isRegionListLoaded = true;
      },
      (fault) => {
        me.showFault(fault);
      }
    );
  },
};
</script>

<style scoped>
/* .lms5040 {
  min-height: calc(100vh - 90px - 2rem) ;
} */

.page-title {
  padding: 0.875rem;
}

.downloads {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.download-tag {
  display: flex;
}

@media (max-width: 1085px) {
  .downloads {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 380px) {
  .download-tag {
    display: block;
  }
}
</style>
